// import React from "react";
// import "../Contact/Contact.css";
// import CIcon from "@coreui/icons-react";
// import { FaWhatsapp } from "react-icons/fa";
// import aboutbanners from "../../assets/images/about-head-banner.jpg";
// import contactimg1 from "../../assets/images/contact-img1.png";
// import contactimg2 from "../../assets/images/contact-img2.png";
// import { FaChevronRight } from 'react-icons/fa';
// const Contact = () => {
//   return (
//     <div className="contactcontainer">
//       <div className="bannersec"
//         style={{
//           backgroundImage: `url(${aboutbanners})`,
//         }}>
//         <h4>Contact</h4>
//         <p>Home <span><FaChevronRight /></span> Contact</p>

//       </div>
//       <div className="containerall">
//         <div className="address-section">
//           <h1 className="contact-title">Ways To Get In Touch With Us</h1>
//           <div className="quote-options">
//             <div className="quote-box">
//               <div className="quote-box-img">
//                 <img src={contactimg1} alt="" />
//               </div>
//               <div className="quote-title">Email</div>
//               <div className="quote-separator"></div>
//               <div className="quote-text">info@connecttovow.com</div>
//             </div>

//             <div className="quote-box">
//               <div className="quote-box-img">
//                 <img src={contactimg2} alt="" />
//               </div>
//               <div className="quote-title">Form</div>
//               <div className="quote-separator"></div>
//               <div className="quote-text">
//                 Fill The Form Below And We Will Get In Touch
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Contact Form Section */}
//         <div className="contact-form-section">
//           <h2 className="contact-title">Contact Form</h2>
//           <div className="form-row">
//             <input
//               type="text"
//               placeholder="Name"
//               className="contactform-input"
//             />
//             <input
//               type="email"
//               placeholder="E-mail"
//               className="contactform-input"
//             />
//           </div>
//           <textarea placeholder="Message" className="form-textarea"></textarea>
//           <button type="submit" className="main-btn">
//             SEND
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default Contact;

import React from "react";
import "../Contact/Contact.css";
import CIcon from "@coreui/icons-react";
import { FaWhatsapp } from "react-icons/fa";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import contactimg1 from "../../assets/images/contact-img1.png";
import contactimg2 from "../../assets/images/contact-img2.png";
import { FaChevronRight } from "react-icons/fa";
import { publicEnquiry } from "../api/api";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
const Contact = () => {
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    subject: Yup.string().required("Subject is required"),
    description: Yup.string().required("Message is required"),
  });
  const initialValues = {
    name: "",
    email: "",
    subject: "",
    number: "",
    description: "",
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      console.log("pass_value", values);
      const response = await publicEnquiry(values);
      console.log("Api_response", response);

      Swal.fire("Success!", response?.message || "Your message has been sent.");
      resetForm();
    } catch (response) {
      console.error("API error:", response);
      Swal.fire("Error!", response?.message, "error");
    }
  };

  return (
    <div className="contactcontainer">
      <div
        className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
        <h4>Contact</h4>
        <p>
          Home{" "}
          <span>
            <FaChevronRight />
          </span>{" "}
          Contact
        </p>
      </div>
      <div className="containerall">
        <div className="address-section">
          <h1 className="contact-title">Ways To Get In Touch With Us</h1>
          <div className="quote-options">
            <div className="quote-box">
              <div className="quote-box-img">
                <img src={contactimg1} alt="" />
              </div>
              <div className="quote-title">Email</div>
              <div className="quote-separator"></div>
              <div className="quote-text">info@connecttovow.com</div>
            </div>

            <div className="quote-box">
              <div className="quote-box-img">
                <img src={contactimg2} alt="" />
              </div>
              <div className="quote-title">Form</div>
              <div className="quote-separator"></div>
              <div className="quote-text">
                Fill The Form Below And We Will Get In Touch
              </div>
            </div>
          </div>
        </div>

        <h2 className="contact-title2">Contact Form</h2>
        <div className="contact-form-section">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form>
                <div className="form-row">
                  <div className="contactform-input">
                    <Field
                      name="name"
                      type="text"
                      placeholder="Name"
                      className="input-filds"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div className="contactform-input">
                    <Field
                      name="email"
                      type="email"
                      placeholder="E-mail"
                      className="input-filds"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div className="contactform-input">
                    <Field
                      name="subject"
                      type="text"
                      placeholder="Subject"
                      className="input-filds"
                    />
                    <ErrorMessage
                      name="subject"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div className="contactform-input">
                    <Field
                      name="number"
                      type="number"
                      placeholder="Phone Number (Optional)"
                      className="input-filds"
                    />
                    <ErrorMessage
                      name="number"
                      component="div"
                      className="error"
                    />
                  </div>
                </div>

                <Field
                  name="description"
                  as="textarea"
                  placeholder="Message"
                  className="form-textarea"
                />
                <ErrorMessage
                  name="description"
                  component="div"
                  className="error"
                />

                <div className="sendsec">
                  <button type="submit" className="main-btn">
                    SEND
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default Contact;
